import React from 'react';
import './OfertasDestacadas.scss';

import OfertasComponent from '../Tienda/components/ProdOfertados/OfertasController';
import DestacadosComponent from '../Tienda/components/ProdDestacados/DestacadosController';
import { useHistory } from 'react-router-dom';

const OfertasDestacadas = () => {

  const history = useHistory();

  return (
    <>
      <section className="my-5">
        <div className="container">
          {/* <div className="row">
            <div className="col-12 mb-5">
              <h2 className="title">
                <strong>+ Ofertas Destacadas</strong>
                <span>de nuestra tienda</span> 
              </h2>
            </div>
          </div> */}
          <OfertasComponent
            updateURL={(url) => history.push(url)}
          />
        </div>
      </section>
      <section className="my-1 py-10" style={{ 'backgroundColor': '#ededeb' }}>
        <div className="container">
          {/* <div className="row">
            <div className="col-12 mb-5">
              <h2 className="title">
                <strong>+ Productos Destacados</strong>
                <span>de nuestra tienda</span>
              </h2>
            </div>
          </div> */}
          <DestacadosComponent
            updateURL={(url) => history.push(url)}
          />

        </div>
      </section>
    </>
  );
};

export default OfertasDestacadas;

